import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Form, Select, DatePicker, Spin, Table } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo-black.svg";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { getIncomeStatement, getBalanceSheet, getBalanceSheetNew, getBalanceSheetOld } from "../../redux/actions/incomeStatement.action.js";
import { useDownloadExcel } from "react-export-table-to-excel";
const BalanceSheetNew = ({ token }) => {
  TabTitle("Balance Sheet")
  const { balanceSheet } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const history = useHistory();
  var date = moment();


  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const [balanceSheetDataset, setBalanceSheetDataset] = useState([]);
  const [balanceSheetOld, setBalanceSheetOld] = useState([]);
  const { submited } = useParams();


  const [year, setYear] = useState(date.format("Y"));
  const [month, setMonth] = useState(date.format("M"));

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Balance Sheet",
    sheet: "Balance Sheet",
  });

  const handlePrint = () => {
    window.print();
  };







  const onFinish = () => {
    let day = moment(`${year} / ${month}`, "YYYY/MM").daysInMonth()
    let dateFormat = month + "/" + day + "/" + year
    const newState = {
      cy_end_date: dateFormat,
    };
    setFormState(newState);
    setLoading(true);
    dispatch(getBalanceSheetNew(token, dateFormat)).then((res) => {
      if (res?.type === "GET_BALANCE_SHEET_SUCCESS") {
        const order = ["Current Liabilities", "Other Current Liability", "Long Term Liability", "Equity"];
        let filterItem = res?.payload?.data.map((v, idx) => {
          if (idx === 1) {
            v?.SubAccount?.sort((a, b) => {
              return order.indexOf(a.subAccountName) - order.indexOf(b.subAccountName);
            })
          }
          return v
        })
        console.log("filterItem", filterItem)
        setBalanceSheetDataset(filterItem);
        setLoading(false);
      }
    });
    dispatch(getBalanceSheetOld(token, dateFormat)).then((res) => {
      if (res?.type === "GET_BALANCE_SHEET_OLD_SUCCESS") {
        setBalanceSheetOld(res?.payload?.data)
        setLoading(false);
      }
    });
  };

  let result =
    balanceSheetOld &&
    balanceSheetOld.reduce(function (r, a) {
      r[a.head_account + a.sub_account + a.accttype] =
        r[a.head_account + a.sub_account + a.accttype] || [];
      r[a.head_account + a.sub_account + a.accttype].push(a);
      return r;
    }, Object.create(null));

  const groupAccountWise = result && Object.values(result);

  console.log({ groupAccountWise })

  const Total = groupAccountWise && groupAccountWise.reduce((acc, item, index) => acc + parseFloat(item.balance), 0)

  console.log({ Total })



  let balance =
    balanceSheetOld &&
    balanceSheetOld.reduce(function (r, a) {
      r[a.head_account] =
        r[a.head_account] || [];
      r[a.head_account].push(a);
      return r;
    }, Object.create(null));

  const grouped = balance && Object.values(balance);


  let grouped_Sub_Account =
    balanceSheetOld &&
    balanceSheetOld.reduce(function (r, a) {
      r[a.sub_account] =
        r[+ a.sub_account] || [];
      r[a.sub_account].push(a);
      return r;
    }, Object.create(null));
  const groupedSubAccount = grouped_Sub_Account && Object.values(grouped_Sub_Account);


  let arrSUM = [];
  if (grouped) {
    for (const group of grouped && grouped) {
      const balance = group && group.reduce((acc, obj) => acc + parseFloat(obj.balance), 0);

      arrSUM.push(balance)
      //   group.push({ "balance": balance.toFixed(2) });
    };
  }


  const totalBalances = [];
  if (groupAccountWise) {
    for (const subList of groupAccountWise) {
      let totalBalance = 0.0; // Start with 0.0 as a float for accurate summing

      for (const account of subList) {
        totalBalance += parseFloat(account.balance);
      }
      // Append the total balance to the list of total balances
      totalBalances.push(totalBalance);
    }
  }

  console.log({ grouped });






  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>
                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {grouped ? (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            onClick={onDownload}
                            style={{
                              borderWidth: "0px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Balance Sheet
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              {
                <div className="row pb-2">
                  <div className="col">
                    <Form
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      layout="horizontal"
                      form={form}
                      name="control-hooks"
                      onFinish={onFinish}
                    >
                      <div className="main_form row">
                        <div className=" col-6">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label htmlFor="gender_id" className="labels width30">
                              Year To:
                            </label>
                            <div style={{ marginBottom: "2px" }} className=" w-100">

                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                value={moment(year)}
                                // defaultValue={moment(yearToId)}
                                onChange={(e) =>
                                  setYear(moment(e).format("YYYY"))
                                }
                                picker="year"
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" col-6">
                          <div className=" d-flex flex-row align-items-baseline">
                            <label className="labels width30">Month To:</label>
                            <div style={{ marginBottom: "2px" }} className=" w-100">
                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                value={moment(month)}
                                // disabled={dateTypeId === "ytd"}
                                onChange={(e) =>
                                  setMonth(moment(e).format("MM"))
                                }
                                picker="month"
                                format={"MM"}
                                mode="month"
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: "0px", display: "flex", justifyContent: "end" }} >
                            {/* <label className=" no_visibility">none</label> */}
                            <Button type="primary" htmlType="submit" className='submit-btn-btm m-0'
                            // disabled={loading}
                            >
                              Search
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {
        <div style={{ display: "none" }}>
          <div className="report-box-main" ref={tableRef} >
            {
              grouped ? (
                grouped.length > 0 ? (
                  <>
                    {
                      grouped && (
                        <>
                          <table>
                            <tr>
                              <td style={{ fontSize: "20px", fontWeight: 900, textAlign: "center", width: "700px" }} colSpan={2}>WARP WEFT</td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: "20px", fontWeight: 900, textAlign: "center", width: "700px" }} colSpan={2}>Balance Sheet</td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: "20px", fontWeight: 900, textAlign: "center", width: "700px" }} colSpan={2}>End of {moment(month, 'MM').format('MMMM')} {year}</td>
                            </tr>
                          </table>
                          <table className="report-table-main" style={{ fontSize: "10px" }} >
                            <tr className="report-row-head">
                              <td className="report-column-head" style={{ backgroundColor: "#d3d3d3", fontWeight: 900, width: "500px" }}>Financial Row</td>
                              <td className="report-column-head" style={{ backgroundColor: "#d3d3d3", fontWeight: 900, textAlign: "right" }}>
                                Amount
                              </td>
                            </tr>
                            {
                              grouped.map((val, idx) => {
                                console.log({ val })
                                let arr = [];
                                console.log({ groupedSubAccount })
                                groupedSubAccount.map((v) => {
                                  return v.filter((value) => {
                                    if (value.head_account === "Assets") {
                                      arr.push({ "Assets": value.sub_account });
                                    }
                                    if (value.head_account === "Liabilities & Equity") {
                                      arr.push({ "Liabilities & Equity": value.sub_account });
                                    }
                                  })
                                })
                                let arrData = [];
                                groupAccountWise.map((v) => {
                                  arrData.push(v[0]);
                                })

                                const sortOrder = ["Current Liabilities", "Other Current Liability", "Long Term Liability", "Equity"];
                                const customSort = (a, b) => {
                                  if (a.hasOwnProperty("Liabilities & Equity") && b.hasOwnProperty("Liabilities & Equity")) {
                                    return sortOrder.indexOf(a["Liabilities & Equity"]) - sortOrder.indexOf(b["Liabilities & Equity"]);
                                  } else if (a.hasOwnProperty("Assets") && b.hasOwnProperty("Assets")) {
                                    return sortOrder.indexOf(a["Assets"]) - sortOrder.indexOf(b["Assets"]);
                                  } else {
                                    return 0;
                                  }
                                };
                                arr.sort(customSort);
                                console.log("arr", arr);

                                return (
                                  <div>
                                    <tr>
                                      <td className="report-hd" style={{ fontWeight: 900 }}>{val[0]?.head_account}</td>
                                    </tr>
                                    <div>
                                      {
                                        arr.map((v) => {
                                          console.log({ v })
                                          let keys = Object.keys(v);
                                          let values = Object.values(v);
                                          console.log("arrData", arrData, keys, val[0]?.head_account, values);
                                          if (keys.includes(val[0]?.head_account)) {
                                            console.log("run");
                                            return values.map((v) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td className="report-hd" style={{ padding: "0 16px", fontWeight: 900 }}>{v}</td>
                                                  </tr>
                                                  {
                                                    arrData.map((arr, index) => {
                                                      if (arr.sub_account === v) {
                                                        return (
                                                          <div>
                                                            <tr>
                                                              <td className="report-hd" style={{ padding: "0 30px", fontWeight: 900 }}>{arr?.accttype}</td>
                                                            </tr>
                                                            {
                                                              balanceSheetOld && balanceSheetOld.map((val, id) => {
                                                                if (val?.accttype === arr?.accttype) {
                                                                  return (
                                                                    <>
                                                                      <tr >
                                                                        <td style={{ padding: "0 50px" }}>
                                                                          {val?.account_display_name}
                                                                        </td>
                                                                        <td className="report-value text-right" style={{ textAlign: "right", fontSize: "10px" }}><span style={{ fontSize: "9px", textAlign: "right" }}>＄</span>{(numeral(val?.balance).format('0,00.00'))}</td>
                                                                      </tr>
                                                                    </>
                                                                  )
                                                                }

                                                              })
                                                            }
                                                            <tr style={{ borderTop: "1px solid black" }}>
                                                              <td style={{ padding: "0 30px", position: "relative" }} >
                                                                <div className="report-hd" style={{ fontWeight: 900 }}>
                                                                  Total {arr?.accttype}
                                                                </div>
                                                              </td>
                                                              <td style={{
                                                                float: "right"
                                                              }} >
                                                                <div className="report-value text-right report-hd"
                                                                  style={{ textAlign: "right", }}>
                                                                  <span style={{ fontSize: "9px", fontWeight: 500 }}>＄</span><span style={{ fontSize: "10px", fontWeight: 900 }}>{numeral(totalBalances[index]).format('0,00.00')}</span>
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          </div>
                                                        )
                                                      }
                                                    })
                                                  }
                                                </>
                                              )
                                            })
                                          }
                                        })
                                      }
                                    </div>
                                    <tr style={{ borderTop: "1px solid black" }}>
                                      <td className="report-hd">
                                        {/* <hr style={{ margin: 2 }} /> */}
                                        <div className="report-hd" style={{ fontWeight: 900 }}>
                                          <div className="report-hd">
                                            Total {val[0]?.head_account}
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        {/* <hr style={{ margin: 2 }} /> */}
                                        <div className="report-hd" style={{ fontWeight: 900, textAlign: "right" }}>
                                          <span style={{ fontSize: "9px", textAlign: "right", fontWeight: 500 }}>＄</span>{numeral(arrSUM[idx]).format('0,00.00')}
                                        </div>
                                      </td>
                                    </tr>
                                  </div>
                                )
                              })
                            }
                          </table>
                        </>
                      )
                    }
                  </>) :
                  (
                    <div className="no-Data">
                      <h1>No Data</h1>
                    </div>
                  )
              )
                : (
                  loading && (
                    <div className="loader" style={{ marginTop: "20px" }}>
                      <Spin size="medium" />
                    </div>
                  )
                )
            }
          </div>
        </div>}
      <div className="table_content international_order"
        style={{ maxWidth: '1150px' }}>
        {balanceSheet?.payload?.data !== undefined ?
          (
            balanceSheet?.payload?.data.length > 0 ? (
              <>
                <div style={{
                  display: "flex",
                  paddingRight: "5px",
                  alignItems: "center",
                  background: "grey", color: "white",
                  height: "30px",
                  position: "sticky",
                  top: "0"
                }} >
                  <div style={{ width: "40px" }}>
                  </div>
                  <div style={{ width: "990px", textAlign: "left" }}>
                    Financial Row
                  </div>
                  <div style={{ width: "110px", textAlign: "right" }}>
                    Amount
                  </div>
                </div>
                {
                  balanceSheetDataset.map((value, index) => {
                    return (
                      <>
                        <Accordion
                          headAccountName={value.headAccountName}
                          subAccount={balanceSheetDataset[index]?.SubAccount}
                          headAccountBalance={balanceSheetDataset[index]?.headAccountBalance}
                          dateTo={formState?.cy_end_date}
                        />
                      </>
                    )
                  })
                }
              </>
            ) : (
              <div className="no-Data">
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div className="loader" style={{ marginTop: "20px" }}>
                <Spin size="medium" />
              </div>
            )
          )
        }
      </div>

    </>
  );
};

export default BalanceSheetNew;


const Accordion = ({ headAccountName, subAccount, subAccountBalance, headAccountBalance, dateTo}) => {
  
  const [isActive, setIsActive] = useState(true);
  return (
    <div>
      <div className="accordion-title" style={{ display: "flex", padding: "5px 5px 4px 6px", fontSize: "20px", alignItems: 'center', height: "26px" }} onClick={() => setIsActive(!isActive)}>
        <div style={{ width: "40px", cursor: "pointer" }}>{isActive ? '-' : '+'}</div>
        <div style={{ width: "760px", fontWeight: "bold", fontSize: 14 }} className="fontBold">{headAccountName}</div>
        <div style={{ width: "250px", fontWeight: "bold", fontSize: 14 }} className="fontBold">{subAccountBalance}</div>
        {!isActive &&
          <div style={{ fontWeight: 800, fontSize: 14, marginLeft: 42, display: "flex", flexDirection: "row" }} className="fontBold">
            {/* <p className="fontBold"> */}
            {"$" + (numeral(headAccountBalance).format('0,00.00'))}
            {/* </p> */}
          </div>
        }
      </div>
      {isActive && <div className="accordion-content">
        {subAccount?.map((v, index) => {
          console.log("VALUE", v);
          return (
            <>
              <AccordionSubInner
                subAccountName={v.subAccountName}
                subAccount={subAccount[index]?.accountTypes}
                subAccountBalance={subAccount[index]?.subAccountBalance}
                dateTo={dateTo}
              />
            </>
          )
        })}
        <hr style={{ margin: "0px" }} />
        <div style={{ fontWeight: 800, fontSize: 14, marginLeft: 42, display: "flex", flexDirection: "row" }} className="fontBold">
          <p className="fontBold" style={{ width: "1010px" }}>
            {"Total" + " " + headAccountName}
          </p>
          <p className="fontBold">
            {"$" + (numeral(headAccountBalance).format('0,00.00'))}
          </p>
        </div>
      </div>}
    </div>
  );
};



const AccordionSubInner = ({ subAccountName, subAccount, subAccountBalance, dateTo }) => {
  const [isActive1, setIsActive1] = useState(true);

  return (
    <div>
      <div className="accordion-title fontBold" style={{ display: "flex", padding: "5px 5px 4px 6px", fontSize: "20px", fontWeight: 'bold', alignItems: 'center', height: "26px" }} onClick={() => setIsActive1(!isActive1)}>
        <div style={{ width: "10px" }}></div>
        <div style={{ width: "40px", cursor: "pointer" }}>{isActive1 ? '-' : '+'}</div>
        <div
          style={{ width: "1000px", fontSize: 14, fontWeight: 900 }}
          className="fontBold"
        >
          {subAccountName}
        </div>
        {!isActive1 &&
          <div style={{ fontWeight: 800, fontSize: 14, marginLeft: 42, display: "flex", flexDirection: "row" }} className="fontBold">
            <p className="fontBold" style={{ textAlign: "right" }}>
              {"$" + (numeral(subAccountBalance).format('0,00.00'))}
            </p>
          </div>
        }
      </div>
      {isActive1 && <div className="accordion-content">
        {subAccount?.map((v, index) => {
          return (
            <>
              <AccordionTypeInner
                subAccounttype={v.accountTypeName}
                tableRow={subAccount[index]?.account_display_childs}
                accountTypeBalance={subAccount[index]?.accountTypeBalance}
                dateTo={dateTo}
              />
            </>
          )
        })}
        <hr style={{ margin: "0px" }} />
        <div style={{ fontWeight: 800, fontSize: 14, marginLeft: 55, display: "flex", flexDirection: "row" }} className="fontBold">
          <p className="fontBold" style={{ width: "990px" }}>
            {"Total" + " " + subAccountName}
          </p>
          <p className="fontBold" style={{ width: "100px", textAlign: "right" }}>
            {"$" + (numeral(subAccountBalance).format('0,00.00'))}
          </p>
        </div>
      </div>}
    </div>
  );
};

const AccordionTypeInner = ({ subAccounttype, tableRow, accountTypeBalance, dateTo }) => {
  const [isActive2, setIsActive2] = useState(true);
  return (
    <div>
      <div className="accordion-title" style={{ display: "flex", padding: "5px 5px 4px 6px", fontSize: "20px", alignItems: 'center', height: "26px" }} onClick={() => setIsActive2(!isActive2)}>
        <div style={{ width: "30px" }}></div>
        <div style={{ width: "40px", cursor: "pointer" }}>{isActive2 ? '-' : '+'}</div>
        <div style={{ width: "1000px", fontWeight: 800, fontSize: 14 }} className="fontBold">{subAccounttype}</div>
        {!isActive2 &&
          <div style={{ fontWeight: 800, fontSize: 14, marginLeft: 42, display: "flex", flexDirection: "row" }} className="fontBold">
            <p className="fontBold">
              {"$" + (numeral(accountTypeBalance).format('0,00.00'))}
            </p>
          </div>
        }
      </div>
      {isActive2 && <div className="accordion-content">
        {tableRow?.map((v, index) => {
          console.log("v", v);

          return (
            <>
              <div style={{ marginLeft: "95px", display: "flex" }}>
                <div style={{ width: "960px" }}>
                  <Link
                    style={{ color: "blue", textDecoration: "underline", padding: "10px", textDecoration: "none" }}
                    target="_blank"
                    rel="noopener noreferrer"
                    to={{ pathname: `/balance-detail`, search: `?account_id=${v?.account_id}&date_to=${dateTo}` }}
                  >  {v.account_display_name}
                  </Link>
                </div>
                <div style={{ width: "100px", textAlign: "right" }}>
                  {"$" + (numeral(v.balance).format('0,00.00'))}
                </div>
              </div>
            </>
          )
        })}
        <hr style={{ margin: "0px" }} />
        <div style={{ fontWeight: 800, fontSize: 14, marginLeft: 75, display: "flex", flexDirection: "row" }} className="fontBold">
          <p className="fontBold" style={{ width: "980px" }}>
            {"Total" + " " + subAccounttype}
          </p>
          <p className="fontBold" style={{ width: "100px", textAlign: "right" }}>
            {"$" + (numeral(accountTypeBalance).format('0,00.00'))}
          </p>
        </div>
      </div>}
    </div>
  );
};

